const LIMECHAT_WHATSAPP_SCRIPT_ID = "limechat-whatsapp-widget-script";
const LIMECHAT_WHATSAPP_SCRIPT_URL =
  "https://s3.ap-south-1.amazonaws.com/cdn.limechat.ai/packs/js/whatsapp_widget/lc_wa_widget.js";
const WHATSAPP_FALLBACK_ICON_URL =
  "https://media.limechat.in/lcmedia/assets/images/whatsapp/static-without-stroke.png";
const BROKEN_ICON_HOST = "limechats3.s3.ap-south-1.amazonaws.com";

const WIDGET_CONFIG = {
  accessToken:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwaG9uZSI6IjkxOTEzNjQzNjc3NiIsImlhdCI6MTc4MTA4NDAxNn0.GsFeJennuOrMJS5HYFHYNzLA5jR03L58zpGuH6gjPcI",
  phoneNumber: "919136436776",
};

function isMobileDevice() {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

function configureMobileWhatsappWidget(widget) {
  if (widget.__bxiMobileWidgetConfigured) {
    return;
  }

  widget.__bxiMobileWidgetConfigured = true;

  const getConfig = widget.getConfig.bind(widget);
  widget.getConfig = async () => {
    const config = await getConfig();

    if (config && isMobileDevice()) {
      // Use the same compact icon layout as desktop instead of LimeChat's
      // mobile-only text button.
      widget.widget_type_mobile = "widget_icon";
      widget.widget_icon_mobile = WHATSAPP_FALLBACK_ICON_URL;
      widget.display_size_mobile =
        widget.display_size_desktop || widget.display_size_mobile;
      widget.disappear_on_scroll_mobile = false;
    }

    return config;
  };

  const setupScrollHandler = widget.setupScrollHandler.bind(widget);
  widget.setupScrollHandler = () => {
    if (!isMobileDevice()) {
      setupScrollHandler();
    }
  };
}

function bridgeLimeChatWhatsappCtor() {
  if (typeof window.LimeChatWhatsapp === "function") {
    return window.LimeChatWhatsapp;
  }

  const bridgeScript = document.createElement("script");
  bridgeScript.textContent =
    'try{if(typeof LimeChatWhatsapp==="function"){window.LimeChatWhatsapp=LimeChatWhatsapp;}}catch(e){}';
  document.head.appendChild(bridgeScript);
  bridgeScript.remove();

  return typeof window.LimeChatWhatsapp === "function"
    ? window.LimeChatWhatsapp
    : null;
}

function getLimeChatLauncher() {
  const nodes = Array.from(
    document.querySelectorAll(".woot-widget-bubble, button.woot-widget-bubble"),
  );
  const launchers = nodes.filter((el) => {
    const rect = el.getBoundingClientRect();
    return (
      rect.width > 20 &&
      rect.width <= 88 &&
      rect.height > 20 &&
      rect.height <= 88 &&
      rect.bottom > 0 &&
      rect.right > 0
    );
  });

  if (!launchers.length) {
    return null;
  }

  return launchers.sort((a, b) => {
    const ra = a.getBoundingClientRect();
    const rb = b.getBoundingClientRect();
    return rb.bottom + rb.right - (ra.bottom + ra.right);
  })[0];
}

function dedupeWhatsappButtons() {
  const buttons = document.querySelectorAll(".WhatsAppButton__root");
  if (buttons.length <= 1) {
    return buttons[0] || null;
  }
  const keep = buttons[buttons.length - 1];
  buttons.forEach((button, index) => {
    if (index < buttons.length - 1) {
      button.remove();
    }
  });
  return keep;
}

function fixWhatsappWidgetIcon(button) {
  const img = button.querySelector("img");
  if (!img) {
    return false;
  }

  const applyFallback = () => {
    if (img.src !== WHATSAPP_FALLBACK_ICON_URL) {
      img.src = WHATSAPP_FALLBACK_ICON_URL;
    }
  };

  img.addEventListener("error", applyFallback, { once: true });

  if (
    img.src.includes(BROKEN_ICON_HOST) ||
    (img.complete && img.naturalWidth === 0)
  ) {
    applyFallback();
  }

  return true;
}

function isLimeChatWidgetOpen() {
  if (document.querySelector(".woot-widget-bubble.woot--close")) {
    return true;
  }

  // LimeChat often mounts `.woot-widget-holder` without #woot-widget-holder.
  // Hidden panels keep huge off-screen rects, so require a viewport-visible box.
  const panels = document.querySelectorAll(".woot-widget-holder");
  for (const panel of panels) {
    if (panel.classList.contains("woot--hide")) continue;
    const rect = panel.getBoundingClientRect();
    if (
      rect.width > 180 &&
      rect.height > 180 &&
      rect.bottom > 0 &&
      rect.top < window.innerHeight
    ) {
      return true;
    }
  }

  return false;
}

function setWhatsappVisible(visible) {
  document
    .querySelectorAll('.WhatsAppButton__root, [class*="WhatsAppButton"]')
    .forEach((el) => {
      el.style.setProperty("visibility", visible ? "visible" : "hidden", "important");
      el.style.setProperty("opacity", visible ? "1" : "0", "important");
      el.style.setProperty("pointer-events", visible ? "auto" : "none", "important");
    });
}

function syncWhatsappWithChatState() {
  const chatOpen = isLimeChatWidgetOpen();
  document.body.classList.toggle("bxi-limechat-open", chatOpen);

  if (isSupportDockCollapsed() || chatOpen) {
    setWhatsappVisible(false);
    return;
  }
  setWhatsappVisible(true);
}

function setupChatOpenObserver() {
  if (window.__bxiChatWhatsappSyncReady) {
    syncWhatsappWithChatState();
    return;
  }

  window.__bxiChatWhatsappSyncReady = true;

  const runSync = () => {
    const chatOpen = isLimeChatWidgetOpen();
    syncWhatsappWithChatState();
    syncSupportDockToggleVisibility();

    if (chatOpen) {
      clearSupportAutoHideTimer();
    } else if (!isSupportDockCollapsed() && !isSupportWidgetsInUse()) {
      scheduleSupportAutoHide();
    }
  };

  window.addEventListener('chatwoot:opened', runSync);
  window.addEventListener('chatwoot:closed', runSync);

  const attachObserver = () => {
    if (!document.body) {
      return false;
    }

    const observer = new MutationObserver(runSync);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class", "style"],
      childList: true,
      subtree: true,
    });

    runSync();
    return true;
  };

  if (!attachObserver()) {
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (attachObserver() || attempts >= 40) {
        window.clearInterval(timer);
      }
    }, 500);
  }
}

function layoutWhatsappBesideLimeChat(button) {
  const iconSize = 56;
  const bottom = 20;
  const chatRight = 20;
  const gap = 12;
  const whatsappRight = chatRight + iconSize + gap;

  // Pin chatbot launcher to the same geometry so both icons share one baseline.
  const launcher = getLimeChatLauncher();
  if (launcher) {
    launcher.style.setProperty("position", "fixed", "important");
    launcher.style.setProperty("width", `${iconSize}px`, "important");
    launcher.style.setProperty("height", `${iconSize}px`, "important");
    launcher.style.setProperty("min-width", `${iconSize}px`, "important");
    launcher.style.setProperty("min-height", `${iconSize}px`, "important");
    launcher.style.setProperty("right", `${chatRight}px`, "important");
    launcher.style.setProperty("bottom", `${bottom}px`, "important");
    launcher.style.setProperty("left", "auto", "important");
    launcher.style.setProperty("top", "auto", "important");
    launcher.style.setProperty("transform", "none", "important");
    launcher.style.setProperty("box-sizing", "border-box", "important");
  }

  button.style.setProperty("position", "fixed", "important");
  button.style.setProperty("z-index", "2147483644", "important");
  button.style.setProperty("left", "auto", "important");
  button.style.setProperty("top", "auto", "important");
  button.style.setProperty("transform", "none", "important");
  button.style.setProperty("box-sizing", "border-box", "important");
  button.style.setProperty("width", `${iconSize}px`, "important");
  button.style.setProperty("height", `${iconSize}px`, "important");
  button.style.setProperty("min-width", `${iconSize}px`, "important");
  button.style.setProperty("min-height", `${iconSize}px`, "important");
  button.style.setProperty("max-width", `${iconSize}px`, "important");
  button.style.setProperty("max-height", `${iconSize}px`, "important");
  button.style.setProperty("padding", "0", "important");
  button.style.setProperty("margin", "0", "important");
  button.style.setProperty("right", `${whatsappRight}px`, "important");
  button.style.setProperty("bottom", `${bottom}px`, "important");
  button.style.setProperty("display", "flex", "important");
  button.style.setProperty("align-items", "center", "important");
  button.style.setProperty("justify-content", "center", "important");
  button.style.setProperty("overflow", "hidden", "important");

  const img = button.querySelector("img");
  if (img) {
    img.style.setProperty("width", `${iconSize}px`, "important");
    img.style.setProperty("height", `${iconSize}px`, "important");
    img.style.setProperty("max-width", "100%", "important");
    img.style.setProperty("max-height", "100%", "important");
    img.style.setProperty("object-fit", "contain", "important");
    img.style.setProperty("margin", "0", "important");
    img.style.setProperty("display", "block", "important");
  }

  return Boolean(launcher);
}


const SUPPORT_DOCK_TOGGLE_ID = "bxi-support-dock-toggle";
const SUPPORT_COLLAPSED_CLASS = "bxi-support-widgets-collapsed";
const SUPPORT_AUTO_HIDE_MS = 6000;
const SUPPORT_INTERACTIVE_SELECTOR =
  '.WhatsAppButton__root, .woot-widget-bubble, .woot--bubble-holder, ' +
  '.woot-widget-holder, .lime-first-time-popup, .bxi-bot-greeting-card, ' +
  '#bxi-support-dock-toggle';

let supportAutoHideTimer = null;
let supportWasChatOpen = false;

function isSupportDockCollapsed() {
  return document.body.classList.contains(SUPPORT_COLLAPSED_CLASS);
}

function isSupportWidgetsInUse() {
  if (isLimeChatWidgetOpen()) {
    return true;
  }

  return Array.from(document.querySelectorAll(SUPPORT_INTERACTIVE_SELECTOR)).some(
    (el) => el.matches(":hover, :focus, :focus-within"),
  );
}

function getSupportDockChevron() {
  return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 14l6-6 6 6" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/></svg>';
}

function clearSupportAutoHideTimer() {
  if (supportAutoHideTimer) {
    window.clearTimeout(supportAutoHideTimer);
    supportAutoHideTimer = null;
  }
}

/**
 * Chatwoot/LimeChat greeting cards often sit under the launcher. Raise them.
 */
function elevateBotGreetingBubble() {
  const holders = document.querySelectorAll(".woot--bubble-holder, #woot-widget-holder, #cw-widget-holder");
  holders.forEach((holder) => {
    holder.style.setProperty("z-index", "2147483645", "important");
  });

  // LimeChat's greeting is relatively positioned in the holder by default,
  // which can place it underneath the fixed launcher. Pin it above both icons.
  const candidates = document.querySelectorAll(
    ".lime-first-time-popup, .woot--bubble-holder > div:not(.woot-widget-bubble), " +
      ".woot--bubble-holder > aside",
  );
  candidates.forEach((el) => {
    if (el.classList?.contains("woot-widget-bubble")) return;
    if (el.id === SUPPORT_DOCK_TOGGLE_ID) return;
    if (el.classList?.contains("WhatsAppButton__root")) return;

    const text = String(el.textContent || "").toLowerCase();
    const looksLikeGreeting =
      text.includes("hello") ||
      text.includes("welcome") ||
      text.includes("help") ||
      Boolean(el.querySelector('button, [class*="close"], [aria-label*="close" i]'));

    if (!looksLikeGreeting) return;

    el.style.setProperty("position", "fixed", "important");
    el.style.setProperty("right", "20px", "important");
    el.style.setProperty("bottom", "88px", "important");
    el.style.setProperty("left", "auto", "important");
    el.style.setProperty("top", "auto", "important");
    el.style.setProperty("transform", "none", "important");
    el.style.setProperty("z-index", "2147483647", "important");
    el.classList.add("bxi-bot-greeting-card");
  });
}

function syncSupportDockToggleVisibility() {
  const toggle = document.getElementById(SUPPORT_DOCK_TOGGLE_ID);
  if (!toggle) return;
  // Arrow only when icons are hidden AND chat panel is not open.
  const show = isSupportDockCollapsed() && !isLimeChatWidgetOpen();
  toggle.style.setProperty("display", show ? "inline-flex" : "none", "important");
  toggle.setAttribute("aria-hidden", show ? "false" : "true");
}

function setSupportWidgetsCollapsed(collapsed, { persist = true } = {}) {
  document.body.classList.toggle(SUPPORT_COLLAPSED_CLASS, collapsed);

  const toggle = document.getElementById(SUPPORT_DOCK_TOGGLE_ID);
  if (toggle) {
    toggle.setAttribute("aria-expanded", collapsed ? "false" : "true");
    toggle.setAttribute("aria-label", "Show support chat options");
    toggle.title = "Show chat options";
    toggle.innerHTML = getSupportDockChevron();
    toggle.dataset.state = collapsed ? "collapsed" : "expanded";
  }
  syncSupportDockToggleVisibility();

  if (collapsed) {
    clearSupportAutoHideTimer();
    setWhatsappVisible(false);
  } else {
    ensureWhatsappWidgetVisible();
    elevateBotGreetingBubble();
    scheduleSupportAutoHide();
  }
}

function ensureSupportDockToggle() {
  let toggle = document.getElementById(SUPPORT_DOCK_TOGGLE_ID);
  if (!toggle) {
    toggle = document.createElement("button");
    toggle.id = SUPPORT_DOCK_TOGGLE_ID;
    toggle.type = "button";
    toggle.className = "bxi-support-dock-toggle";
    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute("aria-label", "Show support chat options");
    toggle.title = "Show chat options";
    toggle.innerHTML = getSupportDockChevron();
    toggle.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      setSupportWidgetsCollapsed(false);
    });
    document.body.appendChild(toggle);
  }
  syncSupportDockToggleVisibility();
  return toggle;
}

function scheduleSupportAutoHide() {
  clearSupportAutoHideTimer();
  if (isSupportDockCollapsed()) return;
  if (isSupportWidgetsInUse()) return;

  supportAutoHideTimer = window.setTimeout(() => {
    if (isSupportWidgetsInUse()) {
      // Still hovering / chatting � try again later.
      scheduleSupportAutoHide();
      return;
    }
    setSupportWidgetsCollapsed(true);
  }, SUPPORT_AUTO_HIDE_MS);
}

function onSupportInteractionStart() {
  clearSupportAutoHideTimer();
  elevateBotGreetingBubble();
}

function onSupportInteractionEnd() {
  window.setTimeout(() => {
    if (!isSupportWidgetsInUse() && !isSupportDockCollapsed()) {
      scheduleSupportAutoHide();
    }
  }, 0);
}

function bindSupportIdleTracking() {
  document.querySelectorAll(SUPPORT_INTERACTIVE_SELECTOR).forEach((el) => {
    if (el.dataset.bxiIdleBound === "true") return;
    el.dataset.bxiIdleBound = "true";
    el.addEventListener("mouseenter", onSupportInteractionStart);
    el.addEventListener("mouseleave", onSupportInteractionEnd);
    el.addEventListener("focusin", onSupportInteractionStart);
    el.addEventListener("focusout", onSupportInteractionEnd);
    el.addEventListener("touchstart", onSupportInteractionStart, { passive: true });
    el.addEventListener("touchend", onSupportInteractionEnd, { passive: true });
  });
}

function setupSupportWidgetsDock() {
  if (window.__bxiSupportWidgetsDockReady) {
    ensureSupportDockToggle();
    bindSupportIdleTracking();
    elevateBotGreetingBubble();
    syncSupportDockToggleVisibility();
    return;
  }
  window.__bxiSupportWidgetsDockReady = true;

  ensureSupportDockToggle();
  bindSupportIdleTracking();
  elevateBotGreetingBubble();

  // Every page load starts visible, then collapses only after genuine idle time.
  setSupportWidgetsCollapsed(false, { persist: false });
  scheduleSupportAutoHide();

  const onChatOpened = () => {
    clearSupportAutoHideTimer();
    supportWasChatOpen = true;
    if (isSupportDockCollapsed()) {
      setSupportWidgetsCollapsed(false, { persist: false });
    }
    clearSupportAutoHideTimer();
    syncWhatsappWithChatState();
    syncSupportDockToggleVisibility();
  };

  const onChatClosed = () => {
    supportWasChatOpen = false;
    syncSupportDockToggleVisibility();
    scheduleSupportAutoHide();
  };

  window.addEventListener("chatwoot:opened", onChatOpened);
  window.addEventListener("chatwoot:closed", onChatClosed);
  window.addEventListener("$chatwoot:opened", onChatOpened);
  window.addEventListener("$chatwoot:closed", onChatClosed);

  // Periodic sync: greeting z-index + idle binds + open-state (LimeChat can mount late).
  window.setInterval(() => {
    elevateBotGreetingBubble();
    bindSupportIdleTracking();
    syncWhatsappWithChatState();
    syncSupportDockToggleVisibility();
    const chatOpen = isLimeChatWidgetOpen();
    if (chatOpen) {
      clearSupportAutoHideTimer();
    } else if (supportWasChatOpen && !isSupportDockCollapsed()) {
      scheduleSupportAutoHide();
    }
    supportWasChatOpen = chatOpen;
  }, 1500);

  window.addEventListener("resize", () => {
    ensureSupportDockToggle();
    ensureWhatsappWidgetVisible();
    elevateBotGreetingBubble();
  });
}

function ensureWhatsappWidgetVisible() {
  const button =
    dedupeWhatsappButtons() || document.querySelector(".WhatsAppButton__root");
  if (!button) {
    return false;
  }

  fixWhatsappWidgetIcon(button);
  const aligned = layoutWhatsappBesideLimeChat(button);
  elevateBotGreetingBubble();
  bindSupportIdleTracking();
  setupSupportWidgetsDock();
  syncWhatsappWithChatState();
  return aligned;
}

function scheduleWhatsappWidgetLayout() {
  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    if (ensureWhatsappWidgetVisible() || attempts >= 40) {
      window.clearInterval(timer);
    }
  }, 400);

  if (!window.__bxiWhatsappRelayoutBound) {
    window.__bxiWhatsappRelayoutBound = true;
    const relayout = () => ensureWhatsappWidgetVisible();
    window.addEventListener("resize", relayout);
    window.addEventListener("scroll", relayout, { passive: true });
  }
}

function runWhatsappWidgetInit() {
  const Ctor = bridgeLimeChatWhatsappCtor();
  if (!Ctor) {
    return false;
  }

  if (window.__limeChatWhatsappInitialized) {
    scheduleWhatsappWidgetLayout();
    return true;
  }

  if (window.__limeChatWhatsappInitPromise) {
    return true;
  }

  if (!window.__limeChatWhatsappInstance) {
    window.__limeChatWhatsappInstance = new Ctor(WIDGET_CONFIG);
    configureMobileWhatsappWidget(window.__limeChatWhatsappInstance);
  }

  window.__limeChatWhatsappInitPromise = window.__limeChatWhatsappInstance
    .initializeWidget()
    .then(() => {
      window.__limeChatWhatsappInitialized = true;
      dedupeWhatsappButtons();
      scheduleWhatsappWidgetLayout();
    })
    .catch((error) => {
      console.error("[WhatsApp Widget] Failed to initialize widget", error);
    });

  return true;
}

export default function initializeLimeChatWhatsapp() {
  if (typeof window === "undefined") {
    return;
  }

  setupChatOpenObserver();
  // Dock toggle can appear even before WhatsApp script finishes loading.
  window.setTimeout(() => setupSupportWidgetsDock(), 800);

  const tryInit = () => {
    if (!runWhatsappWidgetInit()) {
      console.error(
        "[WhatsApp Widget] Script loaded but LimeChatWhatsapp constructor was not found",
      );
    }
  };

  if (runWhatsappWidgetInit()) {
    return;
  }

  const existingScript = document.getElementById(LIMECHAT_WHATSAPP_SCRIPT_ID);
  if (existingScript) {
    if (existingScript.dataset.loaded === "true") {
      tryInit();
      return;
    }
    existingScript.addEventListener("load", tryInit, { once: true });
    return;
  }

  const script = document.createElement("script");
  script.id = LIMECHAT_WHATSAPP_SCRIPT_ID;
  script.type = "text/javascript";
  script.async = true;
  script.src = LIMECHAT_WHATSAPP_SCRIPT_URL;
  script.onload = () => {
    script.dataset.loaded = "true";
    tryInit();
  };
  script.onerror = () => {
    console.error("[WhatsApp Widget] Failed to load lc_wa_widget.js");
  };

  document.head.appendChild(script);
}
